import { toast } from "sonner";

/** Muestra el resultado de agendar/enviar una cita y abre WhatsApp si corresponde. */
export function handleSendResult(data, channel) {
  const wantsEmail = channel === "email" || channel === "both";
  if (wantsEmail) {
    if (data.email_sent) toast.success("Correo enviado al paciente con el enlace para confirmar");
    else if (data.email_error) toast.warning(`${data.email_error}. La cita quedó agendada.`);
  }
  if (data.whatsapp_link) {
    const w = window.open(data.whatsapp_link, "_blank", "noopener");
    if (!w) toast.message("Tu navegador bloqueó la ventana de WhatsApp", { action: { label: "Abrir", onClick: () => window.open(data.whatsapp_link, "_blank") } });
  }
  if (!wantsEmail && !data.whatsapp_link) toast.success("Cita agendada");
}

export async function copyText(text, okMsg = "Enlace copiado") {
  try { await navigator.clipboard.writeText(text); toast.success(okMsg); }
  catch { window.prompt("Copia el enlace:", text); }
}
